function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { forwardRef, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useSingleFrameFlag } from "../../hooks/useSingleFrameFlag";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { resolveIds } from "../../utils";
import { useComposedRef } from "../../hooks/useComposedRef";
import { usePopper } from "react-popper";
import useStyle from "./Popper.style";
import { usePlacement } from "./usePlacement";
import { css } from "@emotion/react";
import { EventSetter } from "../EventSetter";
import { Transition } from "../Transition";
import { useTheme } from "../ThemeProvider/useTheme";
import { usePrevious } from "../../hooks/usePrevious";
import { applySpreaderProp } from "../../utils/applySpreaderProp";
import { transitionDurationToNum } from "../../utils/styleUtils";
import { CarinaContext } from "../CarinaProvider";
import { POPPER_ZINDEX, ZIndexContext } from "../ZIndexProvider";
var getArrowOffset = function(arrowSize, hasShadow) {
    var offset;
    switch(arrowSize){
        case 'large':
            offset = [
                0,
                hasShadow ? 25 : 21
            ];
            break;
        case 'medium':
            offset = [
                0,
                hasShadow ? 18 : 14
            ];
            break;
        default:
            offset = [
                0,
                hasShadow ? 13 : 9
            ];
            break;
    }
    return offset;
};
var sameWidthModifier = {
    name: 'sameWidth',
    phase: 'beforeWrite',
    requires: [
        'computeStyles'
    ],
    fn: function(param) {
        var state = param.state;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px !important");
    },
    effect: function(param) {
        var state = param.state;
        state.elements.popper.style.width = "".concat(state.elements.reference.getBoundingClientRect().width, "px");
    }
};
var Popper = forwardRef(function(_param, ref) {
    var _animationFunction = _param.animationFunction, animationFunction = _animationFunction === void 0 ? 'expressive' : _animationFunction, arrowLabel = _param.arrowLabel, arrowPadding = _param.arrowPadding, arrowSize = _param.arrowSize, arrowStyles = _param.arrowStyles, children = _param.children, flip = _param.flip, hasShadow = _param.hasShadow, hide = _param.hide, isFixed = _param.isFixed, _isOpen = _param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, isRtl = _param.isRtl, onDismiss = _param.onDismiss, _placement = _param.placement, placement = _placement === void 0 ? 'bottom' : _placement, _popperjsModifiers = _param.popperjsModifiers, popperjsModifiers = _popperjsModifiers === void 0 ? [] : _popperjsModifiers, popperjsOptions = _param.popperjsOptions, popperRef = _param.popperRef, popperStyles = _param.popperStyles, preventOverflow = _param.preventOverflow, role = _param.role, isSameWidth = _param.isSameWidth, testID = _param.testID, transitionProps = _param.transitionProps, triggerRef = _param.triggerRef, zIndexIn = _param.zIndex, propDrop = _objectWithoutProperties(_param, [
        "animationFunction",
        "arrowLabel",
        "arrowPadding",
        "arrowSize",
        "arrowStyles",
        "children",
        "flip",
        "hasShadow",
        "hide",
        "isFixed",
        "isOpen",
        "isRtl",
        "onDismiss",
        "placement",
        "popperjsModifiers",
        "popperjsOptions",
        "popperRef",
        "popperStyles",
        "preventOverflow",
        "role",
        "isSameWidth",
        "testID",
        "transitionProps",
        "triggerRef",
        "zIndex"
    ]);
    var _$ref12 = _slicedToArray(useState(false), 2), isAnimating = _$ref12[0], setIsAnimating = _$ref12[1];
    var _$ref1 = _slicedToArray(useState(null), 2), arrowRef = _$ref1[0], setArrowRef = _$ref1[1];
    var _$ref2 = _slicedToArray(useState(null), 2), backupArrowRef = _$ref2[0], setBackupArrowRef = _$ref2[1];
    var _$ref3 = _slicedToArray(useSingleFrameFlag(false), 2), transitionDisabled = _$ref3[0], toggleTransitionDisabled = _$ref3[1];
    var parsedPosition = usePlacement(placement, isRtl);
    var _$ref4;
    var _$ref5 = (_$ref4 = useContext(CarinaContext)) !== null && _$ref4 !== void 0 ? _$ref4 : {
        flags: {
            zIndexUpdates: false
        },
        prefersReducedMotion: false
    }, prefersReducedMotion = _$ref5.prefersReducedMotion, flags = _$ref5.flags;
    var zIndexUpdates = flags.zIndexUpdates;
    var _$ref6;
    var getPopperZIndex = ((_$ref6 = useContext(ZIndexContext)) !== null && _$ref6 !== void 0 ? _$ref6 : {}).getPopperZIndex;
    var _$ref7;
    var zIndex = (_$ref7 = zIndexUpdates ? getPopperZIndex === null || getPopperZIndex === void 0 ? void 0 : getPopperZIndex() : zIndexIn) !== null && _$ref7 !== void 0 ? _$ref7 : POPPER_ZINDEX;
    var theme = useTheme();
    var backupPopperRef = useRef(null);
    var composedRef = useComposedRef(popperRef, backupPopperRef, ref);
    var offset = arrowSize ? getArrowOffset(arrowSize, hasShadow) : [
        0,
        hasShadow ? 8 : 4
    ];
    var _$ref8;
    var _$ref9 = usePopper(triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current, (_$ref8 = popperRef === null || popperRef === void 0 ? void 0 : popperRef.current) !== null && _$ref8 !== void 0 ? _$ref8 : backupPopperRef.current, _objectSpread({
        placement: parsedPosition,
        strategy: isFixed ? 'fixed' : undefined
    }, popperjsOptions, {
        modifiers: [
            {
                name: 'arrow',
                enabled: !!arrowSize,
                options: {
                    element: arrowRef !== null && arrowRef !== void 0 ? arrowRef : backupArrowRef,
                    padding: arrowPadding
                }
            },
            {
                name: 'flip',
                enabled: preventOverflow ? false : !!flip
            },
            {
                name: 'hide',
                enabled: !!hide
            },
            {
                name: 'offset',
                enabled: true,
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                enabled: !!preventOverflow,
                options: {
                    padding: 4,
                    rootBoundary: 'viewport',
                    altAxis: true,
                    altBoundary: true
                }
            },
            {
                name: 'eventListeners',
                enabled: true,
                options: {
                    scroll: isOpen,
                    resize: isOpen
                }
            },
            _objectSpread({}, sameWidthModifier, {
                enabled: !!isSameWidth
            })
        ].concat(_toConsumableArray(popperjsModifiers))
    })), attributes = _$ref9.attributes, popperState = _$ref9.state, styles = _$ref9.styles, update = _$ref9.update;
    var _$ref10;
    var correctedPlacement = (_$ref10 = popperState === null || popperState === void 0 ? void 0 : popperState.placement) !== null && _$ref10 !== void 0 ? _$ref10 : parsedPosition;
    var hyphenIndex = correctedPlacement === null || correctedPlacement === void 0 ? void 0 : correctedPlacement.indexOf('-');
    var slideDirection = hyphenIndex === -1 ? correctedPlacement : correctedPlacement === null || correctedPlacement === void 0 ? void 0 : correctedPlacement.slice(0, hyphenIndex);
    var previousSlideDirection = usePrevious(slideDirection);
    var _$ref11 = useStyle({
        arrowSize: arrowSize,
        arrowStyles: arrowStyles,
        hasShadow: hasShadow,
        placement: correctedPlacement,
        zIndex: zIndex
    }), defaultPopperStyles = _$ref11.defaultPopperStyles, defaultArrowStyles = _$ref11.defaultArrowStyles, popperContainerStyles = _$ref11.popperContainerStyles;
    useEffect(function() {
        if (previousSlideDirection !== slideDirection) {
            return toggleTransitionDisabled();
        }
    }, [
        previousSlideDirection,
        slideDirection,
        toggleTransitionDisabled
    ]);
    var duration = transitionDurationToNum(theme.animation.duration[100]);
    var animationEasing = prefersReducedMotion ? 'linear' : "".concat(animationFunction, ".easeOut");
    var slideTransition = useMemo(function() {
        if (prefersReducedMotion) {
            return undefined;
        }
        var axis = slideDirection === 'left' || slideDirection === 'right' ? 'X' : 'Y';
        var directionMultiplier = slideDirection === 'left' || slideDirection === 'top' ? 1 : -1;
        var enter = {
            transitionDuration: '0ms',
            opacity: 0,
            transform: "translate".concat(axis, "(calc(").concat(directionMultiplier, " * ").concat(theme.spacing[2], "))")
        };
        var inStyles = {
            transform: "translate".concat(axis, "(0)")
        };
        var outStyles = {
            transform: "translate".concat(axis, "(calc(").concat(directionMultiplier, " * ").concat(theme.spacing[2], "))")
        };
        return {
            enter: enter,
            entering: inStyles,
            entered: inStyles,
            exiting: outStyles,
            exited: outStyles,
            transitionProperty: 'transform'
        };
    }, [
        prefersReducedMotion,
        slideDirection,
        theme.spacing
    ]);
    var transitions = useMemo(function() {
        if (prefersReducedMotion || !slideTransition) {
            return [
                'fade'
            ];
        }
        return [
            'fade',
            slideTransition
        ];
    }, [
        slideTransition,
        prefersReducedMotion
    ]);
    var handleEnter = useCallback(function() {
        if (update) {
            update();
        }
        setIsAnimating(true);
    }, []);
    var handleEntered = useCallback(function() {
        setIsAnimating(false);
    }, []);
    var handleExit = useCallback(function() {
        setIsAnimating(true);
    }, []);
    var handleExited = useCallback(function() {
        setIsAnimating(false);
    }, []);
    var calculatedTransitionProps = useMemo(function() {
        return applySpreaderProp(transitionProps, _objectSpread({
            duration: duration,
            easing: animationEasing,
            in: isOpen,
            appear: true,
            unmountOnExit: true,
            onEnter: handleEnter,
            onEntered: handleEntered,
            onExit: handleExit,
            onExited: handleExited,
            transitions: transitions
        }, resolveIds(undefined, testID, 'transition')));
    }, [
        transitionProps,
        isOpen,
        duration,
        animationEasing,
        transitions,
        testID
    ]);
    return _jsxs("div", _objectSpread({
        css: _objectSpread({}, styles.popper, popperContainerStyles),
        style: styles.popper,
        "data-placement": correctedPlacement,
        ref: composedRef
    }, attributes.popper, resolveIds(undefined, testID, 'wrapper'), {
        children: [
            _jsx(Transition, _objectSpread({}, calculatedTransitionProps, {
                children: function(param) {
                    var _$ref = param.ref, transitionStyles = param.styles;
                    return _jsx("div", _objectSpread({
                        css: _objectSpread({}, !isAnimating || !transitionDisabled ? transitionStyles : slideTransition === null || slideTransition === void 0 ? void 0 : slideTransition.enter, {
                            transitionDelay: '50ms'
                        }),
                        ref: _$ref
                    }, resolveIds(undefined, testID, 'transition'), {
                        children: _jsxs(EventSetter, {
                            containerRef: popperRef !== null && popperRef !== void 0 ? popperRef : backupPopperRef,
                            onDismiss: onDismiss,
                            children: [
                                arrowSize && _jsx("div", {
                                    "aria-label": arrowLabel,
                                    css: _objectSpread({}, styles.arrow, defaultArrowStyles),
                                    ref: setArrowRef,
                                    role: role
                                }),
                                _jsx("div", _objectSpread({}, propDrop, {
                                    css: css(defaultPopperStyles, popperStyles)
                                }, injectTestId(testID), {
                                    children: children
                                }))
                            ]
                        })
                    }));
                }
            })),
            !!arrowSize && _jsx("div", {
                css: {
                    position: 'absolute',
                    visibility: 'hidden'
                },
                ref: setBackupArrowRef
            })
        ]
    }));
});
export { Popper };
export default Popper;
